import gql from 'graphql-tag.macro'
export const getSearchResultsQuery = gql`
  query (
    $searchTerm: [String]!
    $size: Int!
    $conditions: [ConditionInput!]!
    $offset: Int!
    $sort: String!
  ) {
    searchAPISearch(
      index_id: "sixtbook_content"
      conditions: $conditions
      sort: {field: $sort, value: "DESC"}
      fulltext: {keys: $searchTerm}
      range: {offset: $offset, limit: $size}
    ) {
      result_count
      documents {
        ... on SixtbookContentDoc {
          title
          url
          changed
          news_categories_name
          field_news_summary
          entity_summary
          type
          public_uid_mail
          entity {
            __typename
            entityId
            ... on NodeNews {
              fieldNewsParagraphs {
                entity {
                  ... on ParagraphNewsImages {
                    fieldNewsImages {
                      url
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
export const getUserSearchResultsQuery = gql`
  query (
    $searchTerm: [String]!
    $size: Int!
    $searchType: [String]!
    $offset: Int!
  ) {
    searchAPISearch(
      index_id: "sixtbook_content"
      conditions: {name: "entity_type", value: $searchType}
      fulltext: {keys: $searchTerm}
      range: {offset: $offset, limit: $size}
    ) {
      result_count
      documents {
        entity {
          entityType
          ... on SixtPeople {
            costCenter
            entityId
            givenName
            surname
            displayName
            fieldPhoto {
              url
            }
            label
            mail
            businessPhones
            entityLabel
            jobTitle
          }
        }
      }
    }
  }
`
export const getDeepLinksQuery = gql`
  query ($searchTerm: [String]!, $size: Int!) {
    searchAPISearch(
      index_id: "sixtbook_content"
      fulltext: {
        keys: $searchTerm
        fields: ["title", "field_free_german_tags", "field_wiki_tags"]
      }
      conditions: [{name: "type", value: ["deep_link"], operator: "="}]
      sort: {field: "_score", value: "DESC"}
      range: {offset: 0, limit: $size}
    ) {
      result_count
      documents {
        ... on SixtbookContentDoc {
          title
          type
          url
        }
      }
    }
  }
`
export const getSearchHistoryQuery = gql`
  query ($empId: String, $searchType: String) {
    getMySearchHistory(empId: $empId, searchType: $searchType) {
      searchTerms
    }
  }
`
export const saveSearchHistory = gql`
  mutation ($empId: String, $searchTerm: String, $searchType: String) {
    saveMySearch(
      empId: $empId
      searchTerm: $searchTerm
      searchType: $searchType
    ) {
      status
      errorMessage
    }
  }
`
export const recentelyUpdatedWiki = gql`
  {
    nodeQuery(
      offset: 0
      limit: 5
      sort: [{field: "changed", direction: DESC}]
      filter: {
        conditions: [
          {field: "type", value: "wiki", operator: EQUAL}
          {field: "status", value: ["1!"], operator: EQUAL}
        ]
      }
    ) {
      entities {
        entityBundle
        ... on NodeWiki {
          title
          nid
          created
          changed
        }
      }
    }
  }
`

export const getWikiSearchResultsQuery = gql`
  query (
    $searchTerm: [String]!
    $size: Int!
    $offset: Int!
    $sort: String!
    $conditions: [ConditionInput!]!
  ) {
    searchAPISearch(
      index_id: "sixtbook_content"
      condition_group: {groups: [{conjunction: OR, conditions: $conditions}]}
      sort: {field: $sort, value: "DESC"}
      fulltext: {keys: $searchTerm}
      range: {offset: $offset, limit: $size}
    ) {
      result_count
      documents {
        ... on SixtbookContentDoc {
          title
          url
          changed
          entity_summary
          type
          entity {
            entityId
            ... on NodeWiki {
              fieldMainTopics {
                entity {
                  entityLabel
                }
              }
              entityLanguage {
                name
              }
            }
            ... on NodeHotel {
              entityLanguage {
                name
              }
            }
            ... on NodeAirline {
              entityLanguage {
                name
              }
            }
          }
        }
      }
    }
  }
`

export const getPeopleSearchResultsQuery = gql`
  query getPeopleSearchResultsQuery(
    $searchTerm: [String]!
    $size: Int!
    $offset: Int!
    $conditions: [ConditionInput!]!
  ) {
    searchAPISearch(
      index_id: "sixtbook_content"
      conditions: $conditions
      fulltext: {keys: $searchTerm}
      range: {offset: $offset, limit: $size}
    ) {
      result_count
      documents {
        entity {
          entityBundle
          ... on SixtPeople {
            entityId
            displayName
            city
            label
            mail
            businessPhones
            country
            department
            mail
            givenName
            surname
            jobTitle
            fieldPhoto {
              url
            }
          }
        }
      }
    }
  }
`
export const getThinkTankSearchResultsQuery = gql`
  query thinkTankSearch(
    $searchTerm: [String]!
    $size: Int!
    $offset: Int!
    $conditions: [ConditionInput!]!
  ) {
    searchAPISearch(
      index_id: "sixtbook_content"
      conditions: $conditions
      sort: {field: "changed", value: "DESC"}
      fulltext: {keys: $searchTerm}
      range: {offset: $offset, limit: $size}
    ) {
      result_count
      documents {
        ... on SixtbookContentDoc {
          entity {
            ... on NodeThinkTank {
              nid
              changed
              created
              entityId
              title
              fieldThinktankDetailedDescrip {
                value
              }
              fieldThinktankStatus
              publicUid {
                entity {
                  fieldFirstName
                  fieldLastName
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`

export const getPeopleSearchFilterFacets = gql`
  query getPeopleSearchFilterFacets(
    $searchType: [String]!
    $searchTerm: [String]!
  ) {
    searchAPISearch(
      index_id: "sixtbook_content"
      conditions: [{name: "entity_type", value: $searchType}]
      sort: {field: "changed", value: "DESC"}
      fulltext: {keys: $searchTerm}
      facets: [
        {
          field: "usage_location"
          limit: 0
          min_count: 1
          missing: false
          operator: "and"
        }
        {
          field: "company_name"
          limit: 0
          min_count: 1
          missing: false
          operator: "and"
        }
        {
          field: "cost_center"
          limit: 0
          min_count: 1
          missing: false
          operator: "and"
        }
        {
          field: "department"
          limit: 0
          min_count: 1
          missing: false
          operator: "and"
        }
      ]
    ) {
      facets {
        name
        values {
          filter
        }
      }
    }
  }
`
